import { render, staticRenderFns } from "./ButtonPermissionExample.vue?vue&type=template&id=45b88bda&scoped=true"
import script from "./ButtonPermissionExample.vue?vue&type=script&lang=js"
export * from "./ButtonPermissionExample.vue?vue&type=script&lang=js"
import style0 from "./ButtonPermissionExample.vue?vue&type=style&index=0&id=45b88bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b88bda",
  null
  
)

export default component.exports